// src/config/moduleLabels.ts
// Rótulos amigáveis dos códigos de módulo de tenant — espelho dos nomes do
// catálogo do backend (seed `contract.module`, api-adminBluelt). Usado só para
// EXIBIÇÃO (ex.: tela Contrato Bluelt); o gate real vive em `moduleAreas.ts`.

import type { TenantModule } from '../types/entitlement';

export const MODULE_LABELS: Record<TenantModule, string> = {
  PO: 'Purchase Order',
  ODP: 'Operations & Demand Planning',
  CD: 'Chosen Distribution',
  AERP: 'AgilizaERP',
  BBI: 'Blue B.I.',
};

// Rótulo amigável de um código de módulo; devolve o próprio código se desconhecido
// (a lista do backend pode crescer — `modules[]` é união aberta na prática).
export const moduleLabel = (code: string): string =>
  MODULE_LABELS[code as TenantModule] ?? code;
